<div class="print-bar d-print-none">
    <button class="print-button" (click)="window.print()" mat-mini-fab aria-label="Printen">
        <mat-icon fontSet="far" fontIcon="fa-print" />
    </button>
</div>

@if (planning) {
    <div class="dagrapport">
        <div class="print-sheet" [style.--pages]="pagesPerSection[0]">
            <table class="print-page">
                <thead>
                    <tr>
                        <td><div class="print-page-space"></div></td>
                    </tr>
                </thead>
                <tfoot>
                    <tr>
                        <td>
                            <div class="print-page-space"></div>
                        </td>
                    </tr>
                </tfoot>
                <tbody>
                    <tr>
                        <td>
                            <div #pageContent data-section="0">
                                <!-- Pagina 1: Dagrapport -->
                                <header class="header">
                                    <img class="logo" src="/assets/logo.svg" alt="Track Line markeringen" />
                                    <h1 class="title">
                                        Dagrapport {{ entitytypes[planning.mainPlanning?.entitytype_key]?.name }}
                                    </h1>
                                </header>

                                <section>
                                    <table class="info-table">
                                        <tbody>
                                            <tr>
                                                <th>Datum</th>
                                                <td>
                                                    {{ planning.mainPlanning?.begindate | date: 'EEEE d MMM yyyy' }}
                                                </td>
                                                <th>Status</th>
                                                <td>{{ dayReport?.status?.name ?? 'Nog geen dagrapport ingevuld' }}</td>
                                            </tr>
                                            <tr>
                                                <th>Projectnummer</th>
                                                <td>{{ planning.afas_project_id }}</td>
                                                <th>Start</th>
                                                <td>{{ planning.mainPlanning?.begindate | date: 'HH:mm' }}</td>
                                            </tr>
                                            <tr>
                                                <th>Opdrachtgever</th>
                                                <td>{{ planning.customer?.name ?? planning.contractor }}</td>
                                                <th>Einde</th>
                                                <td>{{ planning.mainPlanning?.enddate | date: 'HH:mm' }}</td>
                                            </tr>
                                            <tr>
                                                <th>Uitvoerder</th>
                                                <td>{{ planning.performer_user?.name }}</td>
                                                <th>Verkeersmaatregel</th>
                                                <td>{{ planning | planningFieldValue: 'verkeersmaatregel' }}</td>
                                            </tr>
                                            <tr>
                                                <th>Locatie</th>
                                                <td colspan="3">{{ planning.location | locationFormat }}</td>
                                            </tr>
                                            <tr>
                                                <th>Materieel</th>
                                                <td colspan="3">{{ equipment.join('; ') }}</td>
                                            </tr>
                                            <tr>
                                                <th>Werknemer(s)</th>
                                                <td colspan="3">{{ employees.join('; ') }}</td>
                                            </tr>
                                            <tr>
                                                <th>Opmerking</th>
                                                <td class="pre-line" colspan="3">{{ dayReport?.comment }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </section>

                                @if (dayReport) {
                                    <section class="groups">
                                        @for (group of groups; track group.key) {
                                            <table class="group-table">
                                                <thead>
                                                    <tr>
                                                        <th class="group-title" [attr.colspan]="group.paired ? 3 : 2">
                                                            {{ group.label }}
                                                        </th>
                                                    </tr>
                                                    @if (group.paired) {
                                                        <tr class="meting-header">
                                                            <th>Meting</th>
                                                            <th class="value">1</th>
                                                            <th class="value">2</th>
                                                        </tr>
                                                    }
                                                </thead>
                                                <tbody>
                                                    @for (row of group.rows; track $index) {
                                                        <tr>
                                                            <th>{{ row.label }}</th>
                                                            <td class="value">{{ row.value1 }}</td>
                                                            @if (group.paired) {
                                                                <td class="value">{{ row.value2 }}</td>
                                                            }
                                                        </tr>
                                                    }
                                                </tbody>
                                            </table>
                                        }
                                    </section>
                                }

                                @if (productRows.length) {
                                    <table class="data-table">
                                        <thead>
                                            <tr>
                                                <th>Product</th>
                                                <th>Kleur</th>
                                                <th>Leverancier</th>
                                                <th>Cert.nr / Type</th>
                                                <th class="text-end">Verbruik / eenh.</th>
                                                <th>Verbruikseenheid</th>
                                                <th class="text-end">Totaal m²</th>
                                                <th class="text-end">Verbruikt</th>
                                                <th>Eenheid</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            @for (product of productRows; track product.key) {
                                                <tr>
                                                    <td>{{ product.name }}</td>
                                                    <td>{{ product.color }}</td>
                                                    <td>{{ product.supplier }}</td>
                                                    <td>{{ product.certificate }}</td>
                                                    <td class="text-end">
                                                        {{ product.consumption | number: '0.0-3' }}
                                                    </td>
                                                    <td>{{ product.consumptionUnit }}</td>
                                                    <td class="text-end">{{ product.m2 | number: '0.2-2' }}</td>
                                                    <td class="text-end">{{ product.kg | number: '0.2-2' }}</td>
                                                    <td>kg</td>
                                                </tr>
                                            }
                                            <tr class="grand-total">
                                                <td colspan="6">Totaal</td>
                                                <td class="text-end">{{ productTotalM2 | number: '0.2-2' }}</td>
                                                <td class="text-end">{{ productTotalKg | number: '0.2-2' }}</td>
                                                <td>kg</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                }
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            @for (footer of pageFooters(0); track footer.label) {
                <div class="print-sheet-footer" [style.top.mm]="footer.topMm">{{ footer.label }}</div>
            }
        </div>

        @if (hasSpecification) {
            <div class="print-sheet landscape" [style.--pages]="pagesPerSection[1]">
                <table class="print-page">
                    <thead>
                        <tr>
                            <td><div class="print-page-space"></div></td>
                        </tr>
                    </thead>
                    <tfoot>
                        <tr>
                            <td>
                                <div class="print-page-space"></div>
                            </td>
                        </tr>
                    </tfoot>
                    <tbody>
                        <tr>
                            <td>
                                <div #pageContent data-section="1">
                                    <!-- Pagina 2: Specificatie belijning en figuratie (liggend) -->
                                    <section>
                                        <h2 class="page-title">Specificatie belijning en figuratie</h2>

                                        <table class="info-table mb-2">
                                            <tbody>
                                                <tr>
                                                    <th>Datum</th>
                                                    <td>
                                                        {{ planning.mainPlanning?.begindate | date: 'EEEE d MMM yyyy' }}
                                                    </td>
                                                    <th>Projectnummer</th>
                                                    <td>{{ planning.afas_project_id }}</td>
                                                    <th>Opdrachtgever</th>
                                                    <td>{{ planning.customer?.name ?? planning.contractor }}</td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        @if (specificationRows.length) {
                                            <table class="data-table">
                                                <thead>
                                                    <tr>
                                                        <th>Plaats</th>
                                                        <th class="text-end">Aantal</th>
                                                        <th>Markering</th>
                                                        <th class="text-end">m²</th>
                                                        <th>Materiaal</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    @for (row of specificationRows; track row.id) {
                                                        <tr>
                                                            <td>{{ row.location }}</td>
                                                            <td class="text-end">
                                                                {{ row.amount | number: '0.0-2' }} {{ row.unit }}
                                                            </td>
                                                            <td>{{ row.marking }}</td>
                                                            <td class="text-end">{{ row.m2 | number: '0.0-3' }}</td>
                                                            <td>
                                                                {{ row.material | materialProperty: 'name' }}
                                                                @if (
                                                                    row.material | materialProperty: 'colorName';
                                                                    as colorName
                                                                ) {
                                                                    | {{ colorName }}
                                                                    {{ row.material | materialProperty: 'colorRal' }}
                                                                }
                                                            </td>
                                                        </tr>
                                                    }
                                                    <tr class="grand-total">
                                                        <td colspan="3">Totaal</td>
                                                        <td class="text-end">
                                                            {{ specificationTotalM2 | number: '0.0-2' }}
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        } @else {
                                            <p>Geen productie toegevoegd.</p>
                                        }

                                        @if (dayReport?.comment) {
                                            <table class="info-table mt-2">
                                                <tbody>
                                                    <tr>
                                                        <th>Opmerking</th>
                                                        <td class="pre-line">{{ dayReport.comment }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        }
                                    </section>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                @for (footer of pageFooters(1); track footer.label) {
                    <div class="print-sheet-footer" [style.top.mm]="footer.topMm">{{ footer.label }}</div>
                }
            </div>
        }

        <div class="print-sheet" [style.--pages]="pagesPerSection[2]">
            <table class="print-page">
                <thead>
                    <tr>
                        <td><div class="print-page-space"></div></td>
                    </tr>
                </thead>
                <tfoot>
                    <tr>
                        <td>
                            <div class="print-page-space"></div>
                        </td>
                    </tr>
                </tfoot>
                <tbody>
                    <tr>
                        <td>
                            <div #pageContent data-section="2">
                                <!-- Pagina 3: Urenregistratie -->
                                <section>
                                    <h2 class="page-title">Urenregistratie</h2>

                                    <table class="info-table mb-2">
                                        <tbody>
                                            <tr>
                                                <th>Datum</th>
                                                <td>
                                                    {{ planning.mainPlanning?.begindate | date: 'EEEE d MMM yyyy' }}
                                                </td>
                                                <th>Projectnummer</th>
                                                <td>{{ planning.afas_project_id }}</td>
                                            </tr>
                                            <tr>
                                                <th>Opdrachtgever</th>
                                                <td colspan="3">
                                                    {{ planning.customer?.name ?? planning.contractor }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    @for (group of hourGroups; track group.key) {
                                        <table class="data-table hours-table">
                                            <thead>
                                                <tr>
                                                    <th>{{ group.label }}</th>
                                                    <th colspan="3">{{ group.names.join('; ') }}</th>
                                                </tr>
                                                <tr>
                                                    <th class="hours-date">Datum</th>
                                                    <th class="hours-time">Tijd</th>
                                                    <th>Werksoort</th>
                                                    <th>Opmerking</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                @for (row of group.rows; track $index) {
                                                    <tr>
                                                        <td>{{ row.begindate | date: 'dd-MM-yyyy' }}</td>
                                                        <td>
                                                            {{ row.begindate | date: 'HH:mm' }} -
                                                            {{ row.enddate | date: 'HH:mm' }}
                                                        </td>
                                                        <td>
                                                            {{ row.hourtype | hourtype }}
                                                            @if (row.pause) {
                                                                (pauze {{ row.pause | minutes }})
                                                            }
                                                        </td>
                                                        <td class="pre-line">{{ row.comments.join('\n') }}</td>
                                                    </tr>
                                                }
                                            </tbody>
                                        </table>
                                    } @empty {
                                        <p>Geen uren geregistreerd.</p>
                                    }
                                </section>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            @for (footer of pageFooters(2); track footer.label) {
                <div class="print-sheet-footer" [style.top.mm]="footer.topMm">{{ footer.label }}</div>
            }
        </div>
    </div>
}
